<template lang="pug">
#referral-buttons
  //- router-link.btn.btn-link.text-dark.font-weight-bold.mt-3.p-0(:to="{ name: 'Analytics', params: { link: selectedPage.link } }")
  //-   icon.align-text-bottom(icon="chevron-left")
  //-   span.block-title.font-weight-bold.ml-2 連結按鈕成效
  .report.block.bg-white.mt-3
    .row
      .col-12.col-sm-6.col-lg-3
        .block-title.d-inline-block.font-weight-bold.mb-3(
          :data-toggle="toggleType"
          :data-title="tooltips.buttonClicks.description"
          @click="showModal"
        )
          span.align-bottom 連結按鈕總點擊次數
          icon.ml-2(icon="help-circle")
        h1.text-primary(v-if="report.buttonClicks") {{ report.buttonClicks | largeNumberFormat }}
        h1.text-primary(v-else) --
        hr.d-lg-none
      .col-12.col-sm-6.col-lg-3
        .block-title.d-inline-block.font-weight-bold.mb-3(
          :data-toggle="toggleType"
          :data-title="tooltips.clickRate.description"
          @click="showModal"
        )
          span.align-bottom 連結按鈕平均點擊率
          icon.ml-2(icon="help-circle")
        h1.text-primary(v-if="report.clickRate") {{ (report.clickRate * 100) | numberFormat(1) }}%
        h1.text-primary(v-else) --
  .row.mt-3
    .col-12.col-md-6
      .click-rank.block.bg-white
        .block-title.d-inline-block.font-weight-bold(
          :data-toggle="toggleType"
          :data-title="tooltips.buttonClickCounts.description"
          @click="showModal"
        )
          span.align-bottom 點擊排行
          icon.ml-2(icon="help-circle")
        .table.mt-3.mb-0
          .table-head.d-flex.text-light
            .type 連結按鈕
            .clicks 點擊次數
          .table-row.d-flex(
            v-for="(item, i) in report.buttonClickCounts"
            :key="`click-rank-${i}`"
          )
            .type
              .text.text-capitalize {{ item.title || item.buttonType }}
              .text-light.text-truncate {{ item.url }}
            .clicks {{ item.count }}
</template>

<script>
import Icon from '@/components/Icon.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ReferralButtons',
  components: {
    Icon,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
    toggleType: {
      type: String,
      required: true,
    },
    tooltips: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('page', [
      'selectedPage',
    ]),
  },
  watch: {
    toggleType: {
      handler(val) {
        if (val === 'tooltip') {
          this.$nextTick(() => {
            $('[data-toggle="tooltip"]').tooltip('enable');
          });
        } else {
          $('[data-toggle="tooltip"]').tooltip('disable');
        }
      },
      immediate: true,
    },
  },
  methods: {
    showModal() {
      this.$emit('showModal', {
        t: [
          this.tooltips.buttonClicks,
          this.tooltips.clickRate,
          this.tooltips.buttonClickCounts,
        ],
      });
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/styles/setting'

.report,
.click-rank
  padding: 20px

.report
  .block-title,
  .description
    letter-spacing: 0.7px

  h1
    letter-spacing: 0.88px

  .description
    font-size: 12px

  hr
    border-top: 1px solid $primary-200

.click-rank
  .table
    .type
      width: 70%
    .clicks
      width: 30%

    &-head
      .type,
      .clicks,
      .ratio
        padding: 10px 0
    &-row
      border-top: 1px solid $primary-200

      .type,
      .clicks,
      .ratio
        padding: 1rem 0

    .type
      padding-right: 1rem
    .type > .text-light
      font-size: 12px
</style>
